/**
 * Check Screen Size - is on Large Size Screen
 * Desktop, viewport width > 1024px
 */
export const isLargeScreen = () => window.matchMedia('(min-width: 1024px)').matches;

/**
 * Check Screen Size - is on NOT Large Size Screen
 * Not desktop --> Tablet + Mobile
 */
export const isNotLargeScreen = () => window.matchMedia('(max-width: 1023px)').matches;

/**
 * Check Screen Size - is on Middle Size Screen
 * Tablet, viewport width between (375px, 767px]
 */
export const isMiddleScreen = () =>
  window.matchMedia('(min-width: 375px)').matches && window.matchMedia('(max-width: 767px)').matches;

/**
 * Check Screen Size - is on Small Size Screen
 * Mobile, viewport width <= 374px
 */
export const isSmallScreen = () => window.matchMedia('(max-width: 374px)').matches;

/**
 * Check Page Orientation - is on Landscape
 */
export const isLandscape = () => window.matchMedia('(orientation: landscape)').matches;

/**
 * Check Page Orientation - is on Portrait
 */
export const isPortrait = () => window.matchMedia('(orientation: portrait)').matches;
